const supportedSttLanguages = new Set([
  'bg',
  'ca',
  'zh',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fi',
  'fr',
  'de',
  'el',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'lv',
  'lt',
  'ms',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'es',
  'sv',
  'th',
  'tr',
  'uk',
  'vi',
])

export const isSttSupported = (languageCode: string) => supportedSttLanguages.has(languageCode)
